"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { triggerIXEvent } from "../interactions";
import { cj, debounce, EASING_FUNCTIONS, useLayoutEffect } from "../utils";
const tabsContext = /*#__PURE__*/ React.createContext({
    current: "",
    onTabClick: ()=>undefined,
    onLinkKeyDown: ()=>undefined
});
export const TabsWrapper = /*#__PURE__*/ React.forwardRef(function TabsWrapper(_param, ref) {
    var { className = "", fadeIn, fadeOut, easing, current: initialCurrent } = _param, props = _object_without_properties(_param, [
        "className",
        "fadeIn",
        "fadeOut",
        "easing",
        "current"
    ]);
    const [current, setCurrent] = React.useState("");
    const changeTab = React.useCallback((next)=>{
        function updateTab() {
            setCurrent(()=>{
                const nextTabHeader = document.querySelector(`.w-tab-link[data-w-tab="${next}"]`);
                nextTabHeader === null || nextTabHeader === void 0 ? void 0 : nextTabHeader.focus();
                return next;
            });
        }
        const currentTab = document.querySelector(`.w-tab-pane[data-w-tab="${current}"]`);
        const nextTab = document.querySelector(`.w-tab-pane[data-w-tab="${next}"]`);
        var _EASING_FUNCTIONS_easing;
        const easingFn = (_EASING_FUNCTIONS_easing = EASING_FUNCTIONS[easing]) !== null && _EASING_FUNCTIONS_easing !== void 0 ? _EASING_FUNCTIONS_easing : "ease";
        const animation = currentTab === null || currentTab === void 0 ? void 0 : currentTab.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: fadeOut,
            fill: "forwards",
            easing: easingFn
        });
        if (animation) {
            animation.onfinish = ()=>{
                updateTab();
                nextTab === null || nextTab === void 0 ? void 0 : nextTab.animate([
                    {
                        opacity: 0
                    },
                    {
                        opacity: 1
                    }
                ], {
                    duration: fadeIn,
                    fill: "forwards",
                    easing: easingFn
                });
            };
        } else {
            updateTab();
        }
    }, [
        current,
        easing,
        fadeIn,
        fadeOut
    ]);
    const firstRender = React.useRef(true);
    useLayoutEffect(()=>{
        if (!firstRender.current) return;
        firstRender.current = false;
        setTimeout(()=>{
            changeTab(initialCurrent);
        }, 1);
    }, [
        changeTab,
        initialCurrent
    ]);
    const onTabClick = debounce(changeTab);
    const onLinkKeyDown = debounce((event)=>{
        event.preventDefault();
        const currentTab = document.querySelector(`.w-tab-pane[data-w-tab="${current}"]`);
        const allTabs = document.querySelectorAll(".w-tab-pane");
        const firstTab = allTabs[0];
        const lastTab = allTabs[allTabs.length - 1];
        const nextTab = (()=>{
            switch(event.key){
                case "ArrowUp":
                case "ArrowLeft":
                    var _currentTab_previousElementSibling;
                    return (_currentTab_previousElementSibling = currentTab.previousElementSibling) !== null && _currentTab_previousElementSibling !== void 0 ? _currentTab_previousElementSibling : lastTab;
                case "ArrowDown":
                case "ArrowRight":
                    var _currentTab_nextElementSibling;
                    return (_currentTab_nextElementSibling = currentTab.nextElementSibling) !== null && _currentTab_nextElementSibling !== void 0 ? _currentTab_nextElementSibling : firstTab;
                case "Home":
                    return firstTab;
                case "End":
                    return lastTab;
            }
        })();
        if (nextTab) changeTab(nextTab.getAttribute("data-w-tab"));
    });
    return /*#__PURE__*/ React.createElement(tabsContext.Provider, {
        value: {
            current,
            onTabClick,
            onLinkKeyDown
        }
    }, /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, props), {
        className: cj(className, "w-tabs"),
        ref: ref
    })));
});
export const TabsMenu = /*#__PURE__*/ React.forwardRef(function TabsMenu(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        className: cj(className, "w-tab-menu"),
        role: "tablist",
        ref
    }));
});
export const TabsLink = /*#__PURE__*/ React.forwardRef(function TabsLink(_param, ref) {
    var { className = "", children } = _param, props = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    const { current, onTabClick, onLinkKeyDown } = React.useContext(tabsContext);
    const isCurrent = current === props["data-w-tab"];
    const innerRef = React.useCallback((node)=>{
        if (!node) return;
        triggerIXEvent(node, isCurrent);
        if (ref) {
            if (typeof ref === "function") {
                ref(node);
            } else {
                ref.current = node;
            }
        }
    }, [
        isCurrent,
        ref
    ]);
    return /*#__PURE__*/ React.createElement("a", _object_spread_props(_object_spread({}, props), {
        ref: innerRef,
        className: cj(className, "w-inline-block w-tab-link", isCurrent && "w--current"),
        onClick: ()=>onTabClick(props["data-w-tab"]),
        onKeyDown: onLinkKeyDown,
        role: "tab",
        tabIndex: isCurrent ? 0 : -1,
        "aria-selected": isCurrent,
        "aria-controls": props["data-w-tab"]
    }), children);
});
export const TabsContent = /*#__PURE__*/ React.forwardRef(function TabsContent(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        className: cj(className, "w-tab-content"),
        ref
    }));
});
export const TabsPane = /*#__PURE__*/ React.forwardRef(function TabsPane(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    const { current } = React.useContext(tabsContext);
    const isCurrent = current === props["data-w-tab"];
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        className: cj(className, "w-tab-pane", isCurrent && "w--tab-active"),
        role: "tabpanel",
        "aria-labelledby": props["data-w-tab"],
        ref
    }));
});
